export default __webpack_public_path__ + "static/media/bees.aebab067.png";